import { render, staticRenderFns } from "./KomshipExpeditionSchema.vue?vue&type=template&id=5a0ebf2d&scoped=true&"
import script from "./KomshipExpeditionSchema.vue?vue&type=script&lang=js&"
export * from "./KomshipExpeditionSchema.vue?vue&type=script&lang=js&"
import style0 from "./KomshipExpeditionSchema.vue?vue&type=style&index=0&id=5a0ebf2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ebf2d",
  null
  
)

export default component.exports